/* Splendid Jewellery collection desktop grid-view selector. */
(() => {
  const STORAGE_KEY = 'sjCollectionGridColumns';

  function getShell() {
    return document.querySelector('.template-collection .sj-collection-reference-shell');
  }

  function normaliseColumns(value) {
    return String(value) === '3' ? '3' : '4';
  }

  function applyGrid(columns) {
    const shell = getShell();
    if (!shell) return;

    const selected = normaliseColumns(columns);
    shell.querySelectorAll('.collection-listing .product-grid').forEach((grid) => {
      grid.classList.toggle('sj-product-grid--3', selected === '3');
      grid.classList.toggle('sj-product-grid--4', selected === '4');
    });

    shell.querySelectorAll('[data-sj-grid-columns]').forEach((button) => {
      const active = button.dataset.sjGridColumns === selected;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function savedColumns() {
    try {
      return normaliseColumns(sessionStorage.getItem(STORAGE_KEY) || '4');
    } catch (error) {
      return '4';
    }
  }

  function saveColumns(columns) {
    try {
      sessionStorage.setItem(STORAGE_KEY, normaliseColumns(columns));
    } catch (error) {
      /* Storage can be unavailable in strict privacy modes; visual switching still works. */
    }
  }

  function initialise() {
    const shell = getShell();
    if (!shell || shell.dataset.sjReferenceInitialised === 'true') {
      applyGrid(savedColumns());
      return;
    }

    shell.dataset.sjReferenceInitialised = 'true';
    applyGrid(savedColumns());

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-sj-grid-columns]');
      if (!button || !button.closest('.sj-collection-reference-shell')) return;

      event.preventDefault();
      const columns = normaliseColumns(button.dataset.sjGridColumns);
      saveColumns(columns);
      applyGrid(columns);
    });

    /* AJAX filtering replaces the product-grid markup. Re-apply the chosen view automatically. */
    const observer = new MutationObserver(() => applyGrid(savedColumns()));
    observer.observe(shell, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();

/* Splendid Jewellery collection wishlist control. Keeps the existing PDP
   localStorage convention (sj-wishlist-<product-handle>) so products added
   from either surface appear together on /pages/wishlist. */
(() => {
  const PREFIX = 'sj-wishlist-';

  function isSaved(handle) {
    if (!handle) return false;
    try {
      return localStorage.getItem(PREFIX + handle) === '1';
    } catch (error) {
      return false;
    }
  }

  function setSaved(handle, saved) {
    if (!handle) return;
    try {
      localStorage.setItem(PREFIX + handle, saved ? '1' : '0');
    } catch (error) {
      /* Storage can be unavailable in strict privacy modes. */
    }
  }

  function syncButton(button) {
    const handle = button.getAttribute('data-sj-wishlist-toggle');
    const title = button.getAttribute('data-sj-wishlist-title') || 'product';
    const saved = isSaved(handle);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', (saved ? 'Remove ' : 'Add ') + title + (saved ? ' from wishlist' : ' to wishlist'));
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-sj-wishlist-toggle]').forEach(syncButton);
  }

  function initialiseWishlistControls() {
    const shell = document.querySelector('.template-collection .sj-collection-reference-shell');
    if (!shell) return;

    syncButtons(shell);

    if (shell.dataset.sjWishlistObserver !== 'true') {
      shell.dataset.sjWishlistObserver = 'true';
      const observer = new MutationObserver(() => syncButtons(shell));
      observer.observe(shell, { childList: true, subtree: true });
    }

    if (!window.__sjCollectionWishlistClickBound) {
      window.__sjCollectionWishlistClickBound = true;
      document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-sj-wishlist-toggle]');
        if (!button || !button.closest('.sj-collection-reference-shell')) return;

        event.preventDefault();
        event.stopPropagation();

        const handle = button.getAttribute('data-sj-wishlist-toggle');
        setSaved(handle, !isSaved(handle));
        syncButton(button);
      });

      window.addEventListener('storage', (event) => {
        if (event.key && event.key.indexOf(PREFIX) === 0) syncButtons(document);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseWishlistControls, { once: true });
  } else {
    initialiseWishlistControls();
  }

  document.addEventListener('shopify:section:load', initialiseWishlistControls);
})();
